<template>
    <div>
        <v-row>
            <v-col>
                <v-text-field label="우편번호" :value="inputData.postcode" readonly v-bind="inputProps" @click="$refs.daumPostcode.open()" />
            </v-col>
            <v-col cols="auto">
                <v-btn depressed dark color="grey darken-2" class="rounded-0" @click="$refs.daumPostcode.open()">검색</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field label="기본주소" :value="inputData.address1" readonly v-bind="inputProps" />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field label="상세주소" v-model="inputData.address2" v-bind="inputProps" />
            </v-col>
        </v-row>

        <daum-postcode ref="daumPostcode" @change="({ postcode, address }) => Object.assign(inputData, { postcode, address1: address })"></daum-postcode>
    </div>
</template>

<script>
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";

const inputProps = {
    outlined: true,
    dense: true,
    "hide-details": true,
    persistentPlaceholder: true,
    class: "rounded-0",
};

export default {
    components: { DaumPostcode },
    props: ["value"],
    data() {
        return {
            inputData: {
                postcode: null,
                address1: null,
                address2: null,
            },
            inputProps,
        };
    },
    methods: {
        init() {
            const { postcode, address1, address2 } = this.value;
            this.inputData.postcode = postcode;
            this.inputData.address1 = address1;
            this.inputData.address2 = address2;
        },
        sync() {
            const { postcode, address1, address2 } = this.inputData;
            this.$emit("input", { ...this.value, postcode, address1, address2 });
        },
    },
    mounted() {
        if (this.value?.postcode) this.init();
    },
    watch: {
        "value.postcode"() {
            if (this.value.postcode !== this.inputData.postcode) this.init();
        },
        "value.address1"() {
            if (this.value.address1 !== this.inputData.address1) this.init();
        },
        "value.address2"() {
            if (this.value.address2 !== this.inputData.address2) this.init();
        },
        "inputData.postcode"() {
            if (this.value.postcode !== this.inputData.postcode) this.sync();
        },
        "inputData.address1"() {
            if (this.value.address1 !== this.inputData.address1) this.sync();
        },
        "inputData.address2"() {
            if (this.value.address2 !== this.inputData.address2) this.sync();
        },
    },
};
</script>

<style></style>
